export const BLOG_ADMIN_ROLE_IDS = [
  "ac9be322-db89-4beb-854a-46f2c91de374",
  "5aee1e31-cc95-49d9-9ed7-10c4e4b6fdef",
];

export const isBlogAdmin = (user) =>
  !!user?.user_id && BLOG_ADMIN_ROLE_IDS.includes(user?.user_role);

export const getBlogId = (blog) => blog?.blog_id ?? blog?.id ?? null;

export const normalizeBlogTags = (blog) => {
  if (!blog?.blog_tags) return [];
  if (Array.isArray(blog.blog_tags)) return blog.blog_tags;
  return String(blog.blog_tags)
    .split(",")
    .map((tag) => tag.trim())
    .filter(Boolean);
};

export const buildBlogPayload = ({ blog, user, tags }) => ({
  title: blog?.title || "",
  subtitle: blog?.subtitle || "",
  description: blog?.description || "",
  blog_tags: tags || [],
  image_url:
    blog?.imageUrl ||
    blog?.image_url ||
    "https://media.istockphoto.com/id/2174551157/photo/cyber-security-data-protection-business-technology-privacy-concept.jpg?s=2048x2048&w=is&k=20&c=sCjAoM5vMvI7PXGFaTaOnRr1AppyOWmxPHkckruBq_A=",
});
